import { Level } from './level';
import { Hierarchy } from './hierarchy';

export class Dimension {

  // constructor() {
  // }

  buildModel() {
    const dim = this;
    this.levels.forEach((level) => {
      Object.setPrototypeOf(level, Level.prototype);
      level.dimension = dim;
      level.buildModel();
    });
    // Remove system 'all' hierarchy
    this.hierarchies = this.hierarchies.filter((h) => h.name !== 'all');
    this.hierarchies.forEach((hierarchy) => {
      Object.setPrototypeOf(hierarchy, Hierarchy.prototype);
      hierarchy.dimension = dim;
      hierarchy.buildModel();
    });
    const hie = this.getDefaultHierarchy();
  }

  /*
   * Get a level by name.
   */
  getLevel(level) {
    return this.levels.find(ed => ed.name === level);
  }

  /*
   * Get a hierarchy by name.
   */
  getHierarchy(hierarchy) {
    return this.hierarchies.find(ed => ed.name === hierarchy);
  }

  getDefaultHierarchy() {
    if (this.hierarchies) {
      if (this.default_hierarchy_name) {
        return this.getHierarchy(this.default_hierarchy_name);
      }
      return this.hierarchies[0];
    }
    return null;
  }

  toString() {
    const hie = this.getDefaultHierarchy();
    return hie ? hie.toString() : this.name;
  }

}



// WEBPACK FOOTER //
// ./src/common/dimension.js